import { PHONE_IDENTITY_EMAIL_SUFFIX } from "./auth-phone.contract";

export function isPhoneIdentityEmail(
    email: string | null | undefined,
): boolean {
    return Boolean(email?.endsWith(PHONE_IDENTITY_EMAIL_SUFFIX));
}
